export default __webpack_public_path__ + "static/media/flame.0a5880d6.svg";